import React, { FC, useCallback, useState } from "react";
import { Dimensions, Measure } from "components/List";
import { Data, Graph, GraphProps } from "./Graph";
import { LoadingSpinner } from "@xapp/components";

export { Data };

export interface MeasureGraphProps extends Pick<GraphProps, "height" | "data"> {
  fetching?: boolean;
}

export const MeasureGraphNew: FC<MeasureGraphProps> = (props: MeasureGraphProps) => {

  const { fetching } = props;

  const [lastDimens, setLastDimens] = useState<Dimensions>({ width: 1000, height: 1000 });

  const handleMeasure = useCallback((currentLastDimens: Dimensions) => {
    if (currentLastDimens.width !== lastDimens.width) {
      setLastDimens(lastDimens);
    }
  }, [lastDimens]);

  return (
    <Measure onMeasure={handleMeasure}>
      {fetching ? (
        <div style={{ height: props.height, width: lastDimens.width }}>
          <LoadingSpinner loadingText="Loading Analytics" />
        </div>
      ) : (
        <Graph
          {...props}
          width={lastDimens.width}
          height={props.height}
          margin={{ top: 5, right: 10, left: 10, bottom: 5 }}
        />
      )}
    </Measure>
  );
}
